<template>
  <form method="post" @submit.prevent="copyResearch">
    <v-modal
      @hide-modal="$emit('hide-modal')"
      size="md"
    >
      <template v-slot:title>
        <h4>{{ $t('phrase.copy_research') }}</h4>
        <div class="text-muted" v-if="research">
          {{
            $t('sentence.copy_research', {
              researchId: research.id,
              researchTitle: research.title
            })
          }}
        </div>
      </template>
      <template v-slot:body>
        <form></form>
        <div class="pt-2" v-if="research">
          <div class="mb-3">
            <v-text-input
              id="copy-research-title"
              v-model="formData.title"
              label="word.title"
              :required="true"
            />
          </div>

          <div class="mb-3">
            <v-date-picker
              label="word.start_date"
              id="copy-research-start-date"
              v-model="formData.start_date"
              :required="true"
            />
          </div>

          <div class="mb-3">
            <v-organisation-select
              v-model="formData.organisation_id"
              :organisation-id-selected="research.organisation.id"
            />
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="d-flex justify-content-end">
          <v-button
            text="word.copy"
            style-type="primary"
            type="submit"
            :loader="loader"
          />
        </div>
      </template>
    </v-modal>
  </form>
</template>

<script>
import Button from '@/common/components/Button.vue';
import Modal from '@/common/components/Modal.vue';
import TextInput from '@/common/components/inputs/TextInput.vue';
import OrganisationSelect from '@/common/components/inputs/OrganisationSelect.vue';
import DatePicker from '@/common/components/inputs/DatePicker.vue';
import { toFormattedDate } from '@/common/utils/formatting';
import { notify } from '@/common/utils/notify';
import { copyResearch, fetchResearch } from '@/admin/api';

export default {
  name: 'ResearchCopyModal',
  props: {
    researchUuid: {
      type: String,
      required: true,
    },
  },
  components: {
    'v-button': Button,
    'v-date-picker': DatePicker,
    'v-modal': Modal,
    'v-organisation-select': OrganisationSelect,
    'v-text-input': TextInput,
  },
  data() {
    return {
      research: null,
      loader: { loading: false },
      formData: {
        title: '',
        organisation_id: null,
        start_date: null,
      },
    };
  },
  methods: {
    async fetchResearch() {
      const response = await fetchResearch(this.researchUuid);
      this.research = response.data;
      this.formData.title = `${this.research.title} (COPY)`;
      this.formData.organisation_id = this.research.organisation.id;
    },
    async fetch() {
      await this.fetchResearch();
    },
    async copyResearch() {
      this.loader.loading = true;
      const formData = {
        ...this.formData,
        start_date: toFormattedDate(this.formData.start_date),
      };
      const response = await copyResearch(this.researchUuid, formData);

      if (response.status === 201) {
        notify(this.$t('phrase.research_copied'), this.$t('sentence.research_copied'));
        await this.$router.push({
          name: 'admin-research-detail',
          params: {
            uuid: response.data.uuid,
          },
        });
      } else {
        alert('Something went wrong!');
        this.loader.loading = false;
      }
    },
  },
  created() {
    this.fetchResearch();
  },
};
</script>
